import { InputHTMLAttributes, forwardRef } from 'react'

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  error?: string
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        <div className="flex items-center">
          <input
            ref={ref}
            type="radio"
            className={`
              h-4 w-4
              text-primary
              bg-background
              border-input
              focus:ring-2 focus:ring-ring focus:ring-offset-0
              disabled:opacity-50 disabled:cursor-not-allowed
              ${className}
            `}
            {...props}
          />
          {label && (
            <label className="ml-2 text-sm text-foreground">
              {label}
            </label>
          )}
        </div>
        {error && (
          <p className="mt-1 text-xs text-destructive">{error}</p>
        )}
      </div>
    )
  }
)

Radio.displayName = 'Radio'

export default Radio

